import styled from '@emotion/styled';
import MicrositeHero from '~/components/MicrositeHero';
import { DEMO_PHOTOS } from '~/demo';
import { useSections } from '~/hooks/useSections';

interface HeroBlockZetaProps {
	address1?: string;
}

const Wrapper = styled.section`
	position: relative;
	width: 100%;
	color: white;
`;

const HeroFrame = styled.div`
	position: relative;
	width: 100%;
	min-height: 70vh;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const Background = styled.div`
	position: absolute;
	inset: 0;
	z-index: 0;
`;

const TopGradient = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	height: 12rem;
	background: linear-gradient(to bottom, rgba(0, 0, 0, 0.42), transparent);
`;

const BottomGradient = styled.div`
	position: absolute;
	bottom: 0;
	left: 0;
	right: 0;
	height: 12rem;
	background: linear-gradient(to top, rgba(0, 0, 0, 0.75), transparent);
	display: none;
	@media (min-width: ${(props) => props.theme.viewport.large}px) {
		display: block;
	}
`;

const Nav = styled.nav`
	position: relative;
	z-index: 2;
	max-width: 96rem;
	margin: 0 auto;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 1rem 5%;
`;

const NavList = styled.ul`
	display: none;
	gap: 3rem;
	font-size: 1.25rem;
	@media (min-width: ${(props) => props.theme.viewport.large}px) {
		display: flex;
	}
`;

const NavItem = styled.li`
	text-transform: uppercase;
`;

const MobileMenu = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 1rem;
	background: transparent;
	border: none;
	color: white;
	font-size: 1.25rem;
	text-transform: uppercase;
	@media (min-width: ${(props) => props.theme.viewport.large}px) {
		display: none;
	}
`;

const AddressRow = styled.div`
	position: relative;
	z-index: 2;
	max-width: 96rem;
	margin: 0 auto 4rem;
	width: 100%;
	display: none;
	align-items: center;
	justify-content: space-between;
	padding: 0 5%;
	font-size: 2.25rem;
	@media (min-width: ${(props) => props.theme.viewport.large}px) {
		display: flex;
	}
`;

const MobileAddress = styled.div`
	background: black;
	padding: 2rem;
	text-align: center;
	font-size: 2.5rem;
	font-weight: 300;
	@media (min-width: ${(props) => props.theme.viewport.large}px) {
		display: none;
	}
`;

export default function HeroBlockZeta({ address1 }: HeroBlockZetaProps) {
	const sections = useSections();

	return (
		<Wrapper>
			<HeroFrame>
				<Background>
					<MicrositeHero image={DEMO_PHOTOS[0]} />
				</Background>
				<TopGradient />
				<BottomGradient />
				<Nav>
					<NavList>
						{sections.map((section) => (
							<NavItem key={section.id}>
								<a href={`#${section.id}`}>{section.name}</a>
							</NavItem>
						))}
					</NavList>
					<MobileMenu type="button">Menu</MobileMenu>
				</Nav>
				<AddressRow>
					{address1 && <span>{address1}</span>}
					<a href="#overview">↓</a>
				</AddressRow>
			</HeroFrame>
			{address1 && <MobileAddress>{address1}</MobileAddress>}
		</Wrapper>
	);
}
